module.exports = __webpack_public_path__ + "img/green_117.fb099920.png";